type ApiErrBody = {
  message?: string
  error?: {
    message?: string
    code?: string
    details?: Record<string, string[]>
  }
  errors?: Record<string, string[]>
}

export function getRequestErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message && err.message !== 'validation') {
    const ax = err as { response?: { data?: ApiErrBody }; isAxiosError?: boolean }
    if (!ax.response && !('isAxiosError' in err)) {
      return err.message
    }
  }
  const ax = err as { response?: { data?: ApiErrBody } }
  const d = ax.response?.data
  // Laravel API handler: error.details (VALIDATION_ERROR / giriş hataları)
  const fromDetails = d?.error?.details
  if (fromDetails && typeof fromDetails === 'object') {
    const lines = Object.values(fromDetails).flat().filter((line) => typeof line === 'string' && line.trim())
    if (lines.length > 0) return lines.join(' ')
  }
  if (d?.error?.message && d.error.code !== 'VALIDATION_ERROR') {
    return d.error.message
  }
  if (d?.error?.message) return d.error.message
  if (d?.message && typeof d.message === 'string') return d.message
  if (d?.errors && typeof d.errors === 'object') {
    const first = Object.values(d.errors).flat()[0]
    if (first) return first
  }
  return fallback
}
